// Unified callable wrappers for Admin and User Cloud Functions
// - Adds timeout support and minimal retry for transient errors
// - Normalizes error codes

import { functions, httpsCallable } from '@/services/firebase/config'

function shouldRetry(err, retryCodes) {
  const code = err?.code || ''
  const message = String(err?.message || '')
  return retryCodes.some(rc => code.includes(rc)) || /deadline[- ]exceeded/i.test(message)
}

async function callWithRetry(name, payload, { timeout = 120000, retries = 1, retryCodes = ['deadline-exceeded', 'functions/deadline-exceeded'] } = {}) {
  const invoke = () => httpsCallable(functions, name, { timeout })(payload)
  try {
    return await invoke()
  } catch (err) {
    if (retries > 0 && shouldRetry(err, retryCodes)) {
      return await invoke()
    }
    throw err
  }
}

export async function callAdmin(name, payload, options) {
  return callWithRetry(name, payload, options)
}

export async function callUser(name, payload, options) {
  return callWithRetry(name, payload, options)
}
